import {hideCompleteJourneyLevelTaskPopup} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';
import {CompleteTaskPopupTemplate} from '@/views/Loyalty/PopupTemplates';

import LoyaltyModalPopup from './LoyaltyModalPopup';

const CompleteTaskPopup = ({actionInfo}) => {
    const handleClose = () => {
        dispatch(hideCompleteJourneyLevelTaskPopup());
    };

    return (
        <LoyaltyModalPopup>
            <CompleteTaskPopupTemplate onClose={handleClose} onGotIt={handleClose} actionInfo={actionInfo} />
        </LoyaltyModalPopup>
    );
};

export default CompleteTaskPopup;
